module.exports = __webpack_public_path__ + "static/media/supply_kit_1.449d9ff7.png";